import { createContext } from 'react';

type RedirectContextType = [
  string,
  React.Dispatch<React.SetStateAction<string>> | (() => null),
];

export const RedirectContext = createContext<RedirectContextType>([
  '',
  () => null,
]);
